import { Story } from '../../DocTypes';

export const iconAndTextStory: Story = {
  title: 'Icon and text',
  description: 'List with items having an icon and some text',
  coreComponent: {
    html: `<tag-list
    left-icon='Badge2'
    left-icon-accent='atoll'
    primary-field='name'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Jordan Pickford' },
      { name: 'Kyle Walker' },
      { name: 'John Stones' },
      { name: 'Harry Maguire' },
      { name: 'Luke Shaw' }
    ]);
  });
    `,
  },
  // coreComponent_v3: {
  //   html: `<tag3-list
  //   left-icon='Badge2'
  //   left-icon-accent='atoll'
  //   primary-field='name'>
  // </tag3-list>`,
  //   js: `var tagList = document.querySelector('tag3-list');

  //   tagList.setData([
  //     { name: 'Jordan Pickford' },
  //     { name: 'Kyle Walker' },
  //     { name: 'John Stones' },
  //     { name: 'Harry Maguire' },
  //     { name: 'Luke Shaw' }
  //   ]);
  //   `,
  // },
  reactWrapper: {
    jsx: `<TagList
    leftIcon='Badge2'
    leftIconAccent='atoll'
    primaryField='name'
    data={[
      { name: 'Jordan Pickford' },
      { name: 'Kyle Walker' },
      { name: 'John Stones' },
      { name: 'Harry Maguire' },
      { name: 'Luke Shaw' }
    ]}
  />`,
  },
};
